"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.responseReducer = void 0;
var ts_exhaustive_check_1 = require("ts-exhaustive-check");
function responseReducer(state, action) {
    switch (action.type) {
        case "FetchInit":
            return __assign(__assign({}, state), { isLoading: true, isError: false });
        case "FetchSuccess":
            return __assign(__assign({}, state), { isLoading: false, isError: false, loadedQuery: { query: action.query, variables: action.variables, response: action.response } });
        case "FetchFailure":
            return __assign(__assign({}, state), { isLoading: false, isError: true });
        default:
            return (0, ts_exhaustive_check_1.exhaustiveCheck)(action, true);
    }
}
exports.responseReducer = responseReducer;
//# sourceMappingURL=response-reducer.js.map